export default __webpack_public_path__ + "static/media/message-circle.339d8587.svg";